module.exports = __webpack_public_path__ + "media/bootstrap-icons/bag-check-2c308d56.svg";